import { useUpdateReady } from "@/pwa";
import { RefreshCw } from "lucide-react";

/**
 * Subtle "new AlphaCore version ready" bar. Bottom-left, mobile-safe.
 */
export default function UpdateNotice() {
  const { ready, applyUpdate } = useUpdateReady();
  if (!ready) return null;
  return (
    <div className="fixed left-3 right-3 bottom-[calc(env(safe-area-inset-bottom)+80px)] lg:left-6 lg:right-auto lg:bottom-6 z-[60]">
      <div className="kr-card px-4 py-3 flex items-center gap-3 shadow-xl border border-white/10 max-w-[420px]" data-testid="pwa-update-notice">
        <RefreshCw className="h-4 w-4" style={{ color: "rgb(var(--ac-purple))" }} />
        <div className="text-sm flex-1">A new AlphaCore version is ready.</div>
        <button
          onClick={applyUpdate}
          className="text-xs font-mono uppercase tracking-wider px-3 py-1.5 rounded-md border border-white/10 hover:bg-white/5"
          data-testid="pwa-update-refresh"
        >
          Refresh
        </button>
      </div>
    </div>
  );
}
